import { Search } from 'lucide-react'
import { Card, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

export function SearchHeader() {
  return (
    <Card className="relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-orange-400/10 to-transparent dark:from-orange-400/5 rounded-full -translate-y-8 translate-x-8" />
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <CardTitle className="text-2xl font-bold tracking-tight flex items-center gap-2">
              <Search className="h-6 w-6 text-orange-600 dark:text-orange-400" />
              Search Influencers
            </CardTitle>
            <p className="text-muted-foreground">Find Instagram creators that match your criteria and audience</p>
          </div>
          <Badge variant="secondary" className="text-xs">
            Discovery
          </Badge>
        </div>
      </CardHeader>
    </Card>
  )
} 